import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { useInterventionCreation } from '../../context/interventionCreationContext';
import { buildRemoveAssignmentUrl } from './assignment';

export type RemoveAssignmentState = {
  removeAssignment: (pdsIds: number[]) => void;
  isRemoving: boolean;
  hasFailed: boolean;
  dismissError: () => void;
};

/**
 * Retire le technicien des demandes visées, une seule ou toute la sélection : même
 * endpoint, même corps. Les demandes restent à cette étape, elles repassent simplement
 * à « À affecter ».
 */
export function useRemoveAssignment(): RemoveAssignmentState {
  const { state, dispatch } = useInterventionCreation();
  const queryClient = useQueryClient();

  const mutation = useMutation<void, unknown, number[]>({
    mutationFn: async (pdsIds) => {
      if (state.clientId === null) {
        throw new Error('Aucun client sélectionné');
      }

      await axios.post(buildRemoveAssignmentUrl(state.clientId), { pds_ids: pdsIds });
    },
    onSuccess: (_result, pdsIds) => {
      queryClient.invalidateQueries(['exocet-pds-to-simple-assign']);
      // Une demande qu'on vient de désaffecter n'a plus de raison de rester cochée.
      dispatch({
        type: 'setSelectedRequests',
        ids: state.selectedRequestIds.filter((id) => !pdsIds.includes(id))
      });
    }
  });

  return {
    removeAssignment: mutation.mutate,
    isRemoving: mutation.isLoading,
    hasFailed: mutation.isError,
    dismissError: mutation.reset
  };
}
